function Carousel( index, element, options ) {
    this.$element = $( element );
    this.index = index;
    
    this.selectors = {
      wrapper: ".carousel",
      slider: ".carousel__slides",
      items: ".carousel__item",
      itemsExtraTap: ".carousel__item.mobile-extra-tap a",
      image: ".carousel__item img"
    }

    this.states = {
      wrapper: {
        IS_INITIALIZED: "carousel--is-initialized"
      }
    }

    this.options = Object.assign( {}, {
      cellSelector: this.selectors.items,
      selectedAttraction: 0.2,
      friction: 0.8,
      groupCells: true,
      wrapAround: false,
      prevNextButtons: true,
      contain: true,
      cellAlign: "center",
      pageDots: false,
      arrowShape: {
        x0: 10,
        x1: 60, y1: 50,
        x2: 70, y2: 40,
        x3: 30
      }
    }, options );

    this.originalOptions = { ...this.options };

    this.mobileSettings = options.mobileSettings;
    this.currentViewport = $(window).width() < 640 ? "mobile" : "desktop";

    // The additional margin that can be used whether to make the transition
    // to a slider sooner or later.
    this.viewportOffset = 0;


    this.initialize();
  }

Carousel.prototype = Object.assign( {}, Carousel.prototype, {
    initialize: function() {
      this.$wrapper = this.$element.find( this.selectors.wrapper );
      this.$slider = this.$element.find( this.selectors.slider );
      this.$items = this.$element.find( this.selectors.items );
      this.$itemsExtraTap = this.$element.find( this.selectors.itemsExtraTap );
      this.$image = this.$element.find( this.selectors.image );

      this.carouselInMobile = typeof this.$wrapper.data( "carousel-on-mobile" ) === "undefined" ? true : this.$wrapper.data( "carousel-on-mobile" );

      // If the wrapper cannot be found, check if the component itself is the carousel.
      if( !this.$wrapper.length && this.$element.hasClass( this.selectors.wrapper.replace( '.', '' ) ) ) 
        this.$wrapper = this.$element;

      // If window viewport changes, determine slider state and reset min-height.
      $( window )
      .on( "orientationchange", debounce( this.determineSliderState.bind( this ), 200 ) )
      .on( "orientationchange", this._handleResize.bind( this ) );

      window.onWidthResize( () => {
        debounce(this.determineSliderState(), 200);
        this._handleResize();
      } );

      this.$image.on( "load", () => {
        if( this.$slider.hasClass( "flickity-enabled" ) ) this.$slider.flickity( "resize" );
      } );

      this.$itemsExtraTap.on( "click", (e) => {
        this._handleExtraTap(e);
      } )
      this.$itemsExtraTap.on( "focusout", (e) => {
        this._handleExtraTapFocusOut(e);
      } )

      // Determine slider state on initialization.
      this.determineSliderState();
    },

    isInitialized: function() {
      return this.$wrapper.hasClass( this.states.wrapper.IS_INITIALIZED );
    },

    initializeSlider: function() {
      // If carousel is not yet initialized, initialize it.
      
      if( !this.carouselInMobile && $( window ).width() < 1024 )  {
        this.destroySlider(); 
        return;
      }

      if( !this.isInitialized() ) {
        // Initialize slider.
        this.$slider.flickity( this.options );

        this.$wrapper.addClass( this.states.wrapper.IS_INITIALIZED );
      }
    },

    destroySlider: function() {
      // Only destroy when Flickity is initialized.
      if( this.isInitialized() ) {
        this.$slider.flickity( "destroy" );

        this.$wrapper.removeClass( this.states.wrapper.IS_INITIALIZED );
      }
    },

    hasReachedViewportEdge: function() {
      // Get total width of items when combined.
      let totalWidth = 0;

      // Loop through the items to get the total width.
      this.$items.each( function() { 
        totalWidth += $( this ).outerWidth( true ); 
      } );
      
      // Check if the wrapper has reached the edges of the viewport.
      return ( totalWidth - this.viewportOffset ) >= this.$slider.width();
    },

    determineSliderState: function() {
      const hasReachedViewportEdge = this.hasReachedViewportEdge();
      // If on mobile, center the cells.
      if ($(window).width() < 640) {
        $.each(this.mobileSettings, (i, e) => {
          this.options[i] = e;
        });
        this.options.cellAlign = "center";
      }
      else {
        this.options = { ...this.originalOptions  };
      }

      // If the wrapper has reached the edge, turn the carousel into a slider.
      if (hasReachedViewportEdge) {

        if (
          ($(window).width() < 640 && this.currentViewport == "desktop") ||
          ($(window).width() >= 640 && this.currentViewport == "mobile")
        ) {
          this.destroySlider();
        }
        
        this.initializeSlider();

        // Else, destroy the slider.
      } else {
        this.destroySlider();
      }

      this.currentViewport = $(window).width() < 640 ? "mobile" : "desktop";
    },

    refresh: function() {
      if( this.isInitialized() ) {
        this.$slider.flickity( "reloadCells" );
        this.$slider.flickity( "select", 0 );
      }
    },
    
    _handleResize: function( event ) {
      // When the window resizes, reset the min-height of the items;
      // then, trigger resize and revert to the min-height on the CSS.
      if( this.isInitialized() ) {
        this.$items.css( "min-height", "initial" );
        this.$slider.flickity( "resize" );
        this.$items.css( "min-height", '' );
      }
    },

    _handleExtraTapFocusOut: function(event) {
      // console.info('focusout remove class')
      // $('.carousel__item.mobile-extra-tap a').removeClass('first-tap')
    },

    _handleExtraTap: function(event) {
      // console.info('this', $(this))
      event.preventDefault();
      console.log('event', event)
      var allExtraTapLinks = document.querySelectorAll('.carousel__item.mobile-extra-tap a');
      for(var i = 0; i < allExtraTapLinks.length; i++){
        if(event.currentTarget != allExtraTapLinks[i]){ // check here
          allExtraTapLinks[i].classList.remove('first-tap')
        }
      }
      // $('.carousel__item.mobile-extra-tap a').removeClass('first-tap');
      // event.currentTarget.classList.add('first-tap');
      var isMobile = false;
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        isMobile = true;
      }
      
      // console.info('event', event)
      // console.info('isMobile', isMobile)

      if(isMobile) {
        console.info('i am mobile')
        // event.preventDefault();
        

        if (event.currentTarget.classList.contains('first-tap')){
          console.info('already has a class, proceed to link')
          window.location.href = event.currentTarget.href;
          event.currentTarget.classList.remove('first-tap');
        } else {
          event.currentTarget.classList.add('first-tap');
        }
        
      } else {
        console.info('i am not mobile');
        window.location.href = event.currentTarget.href;
      }
    }
} );